export const INTERACTIVE_TOOLTIP_HIDE_DELAY_MS = 300;
